/** Client-side regime read for BTC vs Nasdaq (matches backend thresholds). */

export const BTC_NASDAQ_INTRO =
  'Is Bitcoin a separate asset, or just leveraged tech risk? Correlation on Nasdaq trading days only — BTC is not forward-filled onto weekends.';

export const REGIME_ROWS = [
  {
    id: 'risk_asset',
    range: '≥ +0.40',
    label: 'Risk asset',
    emoji: '🔴',
    tooltip: 'BTC trades as high-beta tech or liquidity. It won’t diversify an equity portfolio.',
  },
  {
    id: 'decoupled',
    range: '−0.20 to +0.20',
    label: 'Decoupled',
    emoji: '🟡',
    tooltip: 'BTC is driven by crypto-specific factors such as flows, halvings and regulation.',
  },
  {
    id: 'alternative',
    range: '≤ −0.20',
    label: 'Alternative / hedge',
    emoji: '🟢',
    tooltip: 'Rare — would support a “digital gold” story versus Nasdaq.',
  },
];

const RISK = 0.4;
const DECOUP = 0.2;

export function fmtSignedCorr(value) {
  if (value == null || Number.isNaN(value)) return '—';
  const sign = value >= 0 ? '+' : '';
  return `${sign}${value.toFixed(2)}`;
}

export function regime(c) {
  if (c == null || Number.isNaN(c)) {
    return { id: 'unknown', label: '—', emoji: '', cssClass: 'neutral' };
  }
  if (c >= RISK) return { ...REGIME_ROWS[0], cssClass: 'risk' };
  if (c <= -DECOUP) return { ...REGIME_ROWS[2], cssClass: 'alternative' };
  return { ...REGIME_ROWS[1], cssClass: 'decoupled' };
}

export function situationAtPoint(c30, c60, c90, spearman90) {
  const r90 = regime(c90);
  const r30 = regime(c30);
  let trend = 'stable';
  if (c30 != null && c90 != null) {
    if (c30 < c90 - 0.15) trend = 'decoupling';
    else if (c30 > c90 + 0.15) trend = 'coupling';
  }
  const headline =
    r90.id === 'risk_asset'
      ? 'Risk asset — BTC moving with Nasdaq.'
      : r90.id === 'alternative'
        ? 'Alternative / hedge — BTC diverging from Nasdaq.'
        : r90.id === 'decoupled'
          ? 'Decoupled — crypto-specific drivers dominate.'
          : 'Regime unclear.';
  let detail = `30d ${fmtSignedCorr(c30)}; 60d ${fmtSignedCorr(c60)}; 90d ${fmtSignedCorr(c90)}. `;
  if (spearman90 != null) detail += `Spearman 90d ${fmtSignedCorr(spearman90)}. `;
  detail += r90.tooltip || '';
  return {
    headline,
    detail,
    r90,
    r30,
    trend,
    primaryCss: r90.cssClass,
  };
}

export function pickCorr(bars, time) {
  return bars?.find((b) => b.time === time)?.value ?? null;
}
